import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Logger } from 'src/app/core/logger';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { WidgetsSectionModel } from 'src/app/models/widgets/widgets-section.model';
import PrettySequenceHelper from 'src/app/shared/form-builder-util/pretty-sequence';
import { CommandUpdateNodeService } from 'src/app/services/command/command-update-node.service';
import { WidgetsMetadataService } from 'src/app/services/widgets/widgets-metadata.service';
import { ToastrService } from 'ngx-toastr';
import { alphaNumericInputValidator } from 'src/app/validators/alpha-numeric-input.validator';
import { Config } from 'src/app/config';

@Component({
  selector: 'appMetadataSection',
  templateUrl: './metadata-section.component.html',
  styleUrls: ['./metadata-section.component.scss']
})
export class MetadataSectionComponent implements OnInit {
  @Input() data: WidgetsSectionModel = new WidgetsSectionModel();  
  public sequence: string = '';
  isFormIdEnabled:boolean = Config.GLOBALS.isFormIdEnabled;
  // Metadata can be edited or only viewed
  @Input() isEdit: boolean = true;    // Default: we can edit data

  // Metadata can be shown from widget area or from metadata area
  // If we show metadata from Widget area, some tasks need to be completed...
  isShownFromWidgetArea = true;      // Default: metadata shown on widget area

  constructor(
    private widgetsService: WidgetsService,
    private widgetsMetadataService: WidgetsMetadataService,
    private commandReplace: CommandUpdateNodeService,
    public cd: ChangeDetectorRef,
    private logger: Logger,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
    if (!this.data.seqHidden)
      this.sequence = this.getPrettySequence(this.data.seq) + '. ';
  }

  public onSequenceHidden() {
    if (!this.data.seqHidden)
      this.sequence = this.getPrettySequence(this.data.seq) + '. ';
    else this.sequence = '';
  }

  public getPrettySequence(seq: number[]): string {
    return PrettySequenceHelper.formatSequence(seq);
  }

  onCancel() {
    this.logger.log('Cancel update section');
  }

  keyPressAlphaNumeric(event) {
      alphaNumericInputValidator(event);          
  }

  onSave() {
    this.commandReplace.executeAsync(this.widgetsService.getLayoutRoot(), this.data)
      .then((updatedNode) => {
        this.data = updatedNode as WidgetsSectionModel;
        this.logger.log("Section updated: "+this.data.label);
        this.toastr.success("Section updated: "+this.data.label);

        if (this.isShownFromWidgetArea) {
          // If modified from widget area: refresh metadata area with new data
          this.widgetsMetadataService.showMetadata(this.data);
        }        
      })
      .catch((error) => {
        this.logger.warn("Update Section Error "+error);
        this.toastr.warning("Error updating section");
      });
  }
}
